import React, { useRef } from 'react';
import { FaLinkedin, FaGithub, FaSun, FaMoon} from 'react-icons/fa';
import { LuDownload } from 'react-icons/lu';
import desktopStyles from '../../styles/navigation/DesktopNavbar.module.css';
import utilities from '../../styles/utilities.module.css';
import { getResumeUrl } from '../../utils/resumeUtils';
import { useTheme } from '../../hooks/useTheme';

// Wrapper components to ensure proper JSX typing with React 19
const LinkedInIcon: React.FC = () => {
  const icon = FaLinkedin({});
  return icon as React.JSX.Element;
};
const GitHubIcon: React.FC = () => {
  const icon = FaGithub({});
  return icon as React.JSX.Element;
};
const ResumeIcon: React.FC = () => {
  const icon = LuDownload({});
  return icon as React.JSX.Element;
};
const SunIcon: React.FC = () => {
  const icon = FaSun({});
  return icon as React.JSX.Element;
};
const MoonIcon: React.FC = () => {
  const icon = FaMoon({});
  return icon as React.JSX.Element;
};

interface NavBarProps {
    currentSection: string;
    onSectionChange: (section: string) => void;
}

const DesktopNavbar: React.FC<NavBarProps> = ({ currentSection, onSectionChange }) => {
    // Theme management
    const { toggleTheme, isLight } = useTheme();

    // Update the current section when the element is clicked
    const navRef = useRef<HTMLElement>(null);
    const handleNavClick = (section: string, e: React.MouseEvent) => {
        e.preventDefault();
        const sectionElement = document.getElementById(section);
        if (sectionElement) {
            sectionElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        onSectionChange(section);
    };

    return (
        <nav className={desktopStyles.navbar} ref={navRef}>
            <ul className={desktopStyles.desktopNavbarItemHolder}>
                <li className={utilities.navItemPaddingCompact}>
                    <a
                        onClick={(e) => handleNavClick('home', e)}
                        href="#home"
                        className={`${utilities.interactivePaddingCompact} ${currentSection === 'home' ? desktopStyles.active : ''}`}
                    >
                        Home
                    </a>
                </li>
                <li className={utilities.navItemPaddingCompact}>
                    <a
                        onClick={(e) => handleNavClick('projects', e)}
                        href="#projects"
                        className={`${utilities.interactivePaddingCompact} ${currentSection === 'projects' ? desktopStyles.active : ''}`}
                    >
                        Projects
                    </a>
                </li>
                <li className={utilities.navItemPaddingCompact}>
                    <a
                        onClick={(e) => handleNavClick('career', e)}
                        href="#career"
                        className={`${utilities.interactivePaddingCompact} ${currentSection === 'career' ? desktopStyles.active : ''}`}
                    >
                        Career
                    </a>
                </li>
                <li className={desktopStyles.separator}>&nbsp;</li>
                <li className={utilities.navItemPaddingCompact}>
                    <a
                        href="https://www.linkedin.com/in/benjaminxgregory"
                        target="_blank"
                        rel="noopener noreferrer"
                        className={utilities.interactivePaddingCompact}
                    >
                        <LinkedInIcon /> LinkedIn
                    </a>
                </li>
                <li className={utilities.navItemPaddingCompact}>
                    <a
                        href="https://github.com/TheShanachie"
                        target="_blank"
                        rel="noopener noreferrer"
                        className={utilities.interactivePaddingCompact}
                    >
                        <GitHubIcon /> GitHub
                    </a>
                </li>
                <li className={utilities.navItemPaddingCompact}>
                    <a
                        href={getResumeUrl()}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={utilities.interactivePaddingCompact}
                    >
                        <ResumeIcon /> Resume
                    </a>
                </li>
                <li className={desktopStyles.separator}>&nbsp;</li>
                <li className={utilities.navItemPaddingCompact}>
                    <button
                        onClick={toggleTheme}
                        className={`${utilities.interactivePaddingCompact} ${desktopStyles.themeToggle}`}
                        aria-label={`Switch to ${isLight ? 'dark' : 'light'} mode`}
                    >
                        {isLight ? <MoonIcon /> : <SunIcon />} 
                        {isLight ? 'Dark' : 'Light'}
                    </button>
                </li>
            </ul>
        </nav>
    );
}

export default DesktopNavbar;
// This component is a placeholder for the mobile version of the navbar.